import type { StylesConfig } from 'src/components/DropdownWrapper/DropdownWrapper';
import styled from '@emotion/styled';
import { dropdownWrapper, addButton } from 'src/assets/colors';

export const ParticipantsInputWrapper = styled('div', { label: 'ParticipantsInputWrapper' })`
    position: relative;
`;

export const AddButton = styled('a', { label: 'AddButton' })`
    position: absolute;
    right: 30px;
    top: 10px;
    width: 49px;
    height: 20px;
    font-size: 11px;
    border-radius: 0;
    background: ${addButton.bgColor};
    border: 0;
    color: ${addButton.txtColor};
    padding: 2px 4px 2px 20px;
    font-weight: 400;
    text-decoration: none;
    display: inline-block;
    line-height: 1.45;
    box-sizing: border-box;

    &::before {
        content: '+';
        position: absolute;
        display: inline-block;
        width: 16px;
        height: 20px;
        line-height: 1.65;
        bottom: 0;
        left: 0;
        top: 0;
        text-align: center;
        background: ${addButton.bgColorIcon};
    }

    &:hover {
        color: ${addButton.txtColor};
        opacity: 0.9;
    }
`;

export const getParticipantsSelectStyles = <T, IsMulti extends boolean>(): StylesConfig<T, IsMulti> => ({
    control: (base) => ({
        ...base,
        minHeight: '40px',
        height: '40px',
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0 8px',
        height: '40px',
    }),
    input: (base) => ({
        ...base,
        fontSize: '14px',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: '12px',
    }),
    placeholder: (base) => ({
        ...base,
        fontSize: '14px',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: '12px',
    }),
    singleValue: (base) => ({
        ...base,
        fontSize: '14px',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: '12px',
    }),
    clearIndicator: (base) => ({
        ...base,
        display: 'flex',
        padding: '4px',
        marginRight: '44px',
        cursor: 'pointer',
        color: dropdownWrapper.noOptions.txtColor,
        '&:hover': {
            color: dropdownWrapper.control.txtColor,
        },
    }),
    menu: (base) => ({
        ...base,
        zIndex: 9999,
    }),
    option: (base, state) => ({
        ...base,
        fontSize: '14px',
        backgroundColor: state.isSelected
            ? dropdownWrapper.option.bgColorSelected
            : state.isFocused
              ? dropdownWrapper.option.bgColorFocused
              : 'transparent',
        color: dropdownWrapper.control.txtColor,
        cursor: 'pointer',
        '&:active': {
            backgroundColor: dropdownWrapper.option.bgColorHover,
        },
    }),
});
